import { SEGMENTS, useFlowStore } from '@/features/configurator/flow.store';
import styles from './ls-step-bar.module.scss';

interface Props {
  onCartClick: () => void;
}

/**
 * Полоса шагов внизу модуля: разделы пути и корзина.
 *
 * Логика та же, что у полосы в шапке effective-records, — те же отрезки,
 * та же доля заполнения текущего. Разошлись только место и вид: здесь это
 * закреплённая внизу плашка фирменным цветом, а не строка под шапкой.
 * Поэтому компонент свой, а сведения о пути общие: расходиться им нельзя.
 *
 * Текущий раздел не нажимается. Нажатие на него дозаполняло бы полосу,
 * будто шаг пройден, хотя человек с него никуда не уходил.
 */
export function LsStepBar({ onCartClick }: Props) {
  const step = useFlowStore((s) => s.step);
  const progress = useFlowStore((s) => s.stepProgress);
  const entryStep = useFlowStore((s) => s.entryStep);
  const isReachable = useFlowStore((s) => s.isReachable);
  const goTo = useFlowStore((s) => s.goTo);

  const currentIndex = SEGMENTS.findIndex((segment) => segment.steps.includes(step));

  return (
    <div className={styles['ls-step-bar']}>
      <nav
        className={styles['ls-step-bar__steps']}
        aria-label={`Шаг ${currentIndex + 1} из ${SEGMENTS.length}`}
      >
        {SEGMENTS.map((segment, index) => {
          const target = entryStep(segment);
          const isDone = index < currentIndex;
          const isCurrent = index === currentIndex;
          const isOpen = !isCurrent && Boolean(target && isReachable(target));
          const fill = isDone ? 1 : isCurrent ? progress : 0;

          return (
            <button
              key={segment.label}
              className={[
                styles['ls-step-bar__step'],
                isCurrent ? styles['ls-step-bar__step--is-current'] : '',
                isOpen ? styles['ls-step-bar__step--is-open'] : '',
              ].join(' ')}
              type="button"
              disabled={!isOpen}
              onClick={() => target && goTo(target)}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <span className={styles['ls-step-bar__label']}>{segment.label}</span>
              <span className={styles['ls-step-bar__line']}>
                <span
                  className={styles['ls-step-bar__fill']}
                  style={{ transform: `scaleX(${fill})` }}
                />
              </span>
            </button>
          );
        })}
      </nav>

      <button
        className={styles['ls-step-bar__cart']}
        type="button"
        onClick={onCartClick}
        aria-label="Корзина"
      >
        <span className={styles['ls-step-bar__cart-icon']} />
      </button>
    </div>
  );
}
